import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PartService from "../../Controller/PartController"
import SerialFormatService from "../../../Setup/controller/SerialFormat/SerialFormatController"
import TaxCodeService from "../../../Setup/controller/TaxCodesController/TaxCodeController"
import { handleChange, handleSubmit } from "../../Controller/UpdateFinancialController";

import HelpSite from "../../../Common/HelpLink";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import StockSerialHistoryModal from "./StockSerialHistoryModal";
import Draggable from 'react-draggable';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
function PartFinancials({ StockID, onClose }) {

    // StockID = localStorage.getItem('StockID');
    const [isMinimized, setIsMinimized] = useState(false);
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const [formData, setFormData] = useState({
        vc_SerialFormat: '', bnt_SerialRangeFrom: '', bnt_SerialRangeTo: "",
        vc_SerialPrefix: '', SerialTracking: '0', PK_StockLocation_ID: '0'
    });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const PartID = StockID;
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [StockLocationList, setStockLocation] = useState([]);
    const [stockSerialList, setStockSerialList] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [stockSerialID, setStockSerialID] = useState("0");

    const [currentPage, setCurrentPage] = useState(1); // Current page
    const [totalPages, setTotalPages] = useState(1); // Total number of pages
    const [searchQuery, setSearchQuery] = useState('');
    const [poCount, setPOCount] = useState(0);

    const [sortConfig, setSortConfig] = useState({ key: 'PK_StockSerial_ID', direction: 'desc' });
    const setPageSizeInCookie = (pageSize) => {
        document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
    };

    const getPageSizeFromCookie = () => {
        const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
        return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
    };
    const [pageSize, setPageSize] = useState(getPageSizeFromCookie());
    const fetchSerialFormat = async () => {
        try {

            const data = await PartService.GetPartByID(redirectCallback, PartID);
            const SerialFormat = await SerialFormatService.GetSerialFormat(redirectCallback);

            if (data.length > 0) {
                setFormData({
                    ...formData,
                    vc_SerialFormat: data[0].vc_SerialFormat ?? SerialFormat[0].vc_Format,
                    bnt_SerialRangeFrom: data[0].bnt_SerialRangeFrom ?? SerialFormat[0].RangeFrom,
                    bnt_SerialRangeTo: data[0].bnt_SerialRangeTo ?? SerialFormat[0].RangeTo,
                    vc_SerialPrefix: data[0].vc_SerialPrefix ?? SerialFormat[0].Prefix,
                    SerialTracking: '0',
                    PK_StockLocation_ID: '0'


                });
            }
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };

    useEffect(() => {
        if (StockID > 0) {
            //  fetchSerialFormat();
            fetchStockLocations(currentPage, pageSize);
        }

    }, [StockID, currentPage, pageSize]);

    useEffect(() => {
        if (StockLocationList.length > 0) {
            setFormData(prevFormData => ({
                ...prevFormData,
                PK_StockLocation_ID: StockLocationList[0].PK_StockLocation_ID,
            }));
        }
    }, [StockLocationList]);

    const fetchStockLocations = async (currentPage, pageSize) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const PartID = StockID;
            const listOfLocations = await PartService.GetPartLocation(redirectCallback, StockID);

            setStockLocation(listOfLocations);

            if (listOfLocations.length > 0) {
                // Automatically select the first option
                const firstLocationID = listOfLocations[0].PK_StockLocation_ID;

                setFormData(prevFormData => ({
                    ...prevFormData,
                    PK_StockLocation_ID: firstLocationID
                }));

                await fetchSerialHistory(firstLocationID, formData.SerialTracking, currentPage, pageSize);
            }
        } catch (error) {
            console.error('Error fetching locations:', error);
        }
    };
    const fetchSerialHistory = async (StockLocationID, SerialTracking, page, size) => {
        try {

            const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
            const PageSize = size.toString();

            const listOfLocations = await PartService.GetAllNewSerialTracking(StockLocationID, SerialTracking, Start.toString(), PageSize.toString(),
                searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString());
            setStockSerialList(listOfLocations);

            const leadCount = await PartService.GetSerialTrackingCount(StockLocationID, SerialTracking, searchQuery);
            setPOCount(leadCount[0].TotalRecords);
            setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize));
        } catch (error) {
            console.error('Error fetching locations:', error);
        }
    };


    const handleFieldChange = async (event) => {
        handleChange(event, formData, setFormData);

        const { name, value } = event.target;
        let updatedFormData = { ...formData, [name]: value };

        // Validate dec_Quantity field to allow only decimal values
        if (name === 'vc_SerialFormat') {
            // Check if the input is a valid decimal number
            if (/^\d+$/.test(value)) {
                updatedFormData.vc_SerialFormat = value;
            } else {
                // If the input is not a valid decimal number, reset the field to the previous value
                updatedFormData.vc_SerialFormat = formData.vc_SerialFormat || '';
            }
        }
        if (name === 'bnt_SerialRangeFrom') {
            // Check if the input is a valid decimal number
            if (/^\d+$/.test(value)) {
                updatedFormData.bnt_SerialRangeFrom = value;
            } else {
                // If the input is not a valid decimal number, reset the field to the previous value
                updatedFormData.bnt_SerialRangeFrom = formData.bnt_SerialRangeFrom || '';
            }
        }
        if (name === 'bnt_SerialRangeTo') {
            // Check if the input is a valid decimal number
            if (/^\d+$/.test(value)) {
                updatedFormData.bnt_SerialRangeTo = value;
            } else {
                // If the input is not a valid decimal number, reset the field to the previous value
                updatedFormData.bnt_SerialRangeTo = formData.bnt_SerialRangeTo || '';
            }
        }
        if (name === 'PK_StockLocation_ID') {
            setStockSerialList([]);
            if (value > 0) {
                await fetchSerialHistory(value, formData.SerialTracking, "0", pageSize);
            }
        }
        setFormData(updatedFormData);
    };

    const [error, setError] = useState("");



    const handleHistoryClick = async (event, PK_StockSerial_ID) => {
        event.stopPropagation();
        setIsModalOpen(true);
        setStockSerialID(PK_StockSerial_ID);
    };
    const handleCloseModal = () => {
        setIsModalOpen(false);
        setStockSerialID("0");
    };
    const toggleMinimize = () => {
        setIsMinimized(!isMinimized);
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const handleRadioChange = async (event) => {
        const { name, value } = event.target;
        setStockSerialList([]);
        if (formData.PK_StockLocation_ID > 0) {
            await fetchSerialHistory(formData.PK_StockLocation_ID, value, "0", pageSize);
        }
        setFormData({
            ...formData,
            [name]: value
        });
    };
    const handlePageSizeChange = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
        setPageSizeInCookie(newPageSize);
        setCurrentPage(1); // Reset to the first page
    };
    const handleSearchButtonClick = async () => {
        setCurrentPage(1); // Reset to first page
        setStockSerialList([]); // Clear previous data
        const query = searchQuery.toLowerCase(); // Use current searchQuery state

        const listOfLocations = await PartService.GetAllNewSerialTracking(formData.PK_StockLocation_ID, formData.SerialTracking, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString());
        setStockSerialList(listOfLocations);

        const leadCount = await PartService.GetSerialTrackingCount(formData.PK_StockLocation_ID, formData.SerialTracking, query.toString());
        setPOCount(leadCount[0].TotalRecords);
        setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize));
    };
    const handlePageChange = (page) => {
        setStockSerialList([]);
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);

        }
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <div className="row mb-3">
                <div className="col-sm-12" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Financials" Module="5" />

                </div>
            </div>

            <div className="modal fade stockSerialSearchModal show d-block" id="stockSerialSearchModal" tabIndex="-1" aria-labelledby="stockSerialSearchModalLabel" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-lg">
                    <Draggable handle=".modal-content" onStart={handleStart}
                        cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">

                        <div className="modal-content" style={{ height: '100%', width: '100%' }}>
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">Serial Tracking History</h5>


                                <span>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <button type="button" className="close" onClick={toggleMinimize} aria-label="Minimize" >
                                        <span aria-hidden="true">{isMinimized ? '+' : '-'}</span>
                                    </button>

                                </span>


                            </div>
                            {!isMinimized && (
                                <div className="modal-body">



                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                        <label htmlFor="vc_SerialPrefix" className="col-sm-2 col-form-label">Select Location</label>
                                        <div className="col-sm-4">
                                            <select name="PK_StockLocation_ID" className='form-control' value={formData.PK_StockLocation_ID} onChange={handleFieldChange}>
                                                <option value="0">Select Location</option>
                                                {StockLocationList.map((location) => (
                                                    <option key={location.PK_StockLocation_ID} value={location.PK_StockLocation_ID}>
                                                        {location.vc_Name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                    </div>
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                        <label htmlFor="Type" className="col-sm-2 col-form-label"></label>
                                        <div className="col-sm-2">
                                            <div>
                                                <input className="form-check-input" type="radio" checked={formData.SerialTracking === '0'} name="SerialTracking" value="0" onChange={handleRadioChange} />
                                            </div>
                                            <div style={{ "marginLeft": "17px" }}>
                                                <label className="">View All</label>
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div>
                                                <input className="form-check-input" type="radio" checked={formData.SerialTracking === '1'} name="SerialTracking" value="1" onChange={handleRadioChange} />
                                            </div>
                                            <div style={{ "marginLeft": "17px" }}>
                                                <label className="">Unallocated</label>
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div>
                                                <input className="form-check-input" type="radio" checked={formData.SerialTracking === '2'} name="SerialTracking" value="2" onChange={handleRadioChange} />
                                            </div>
                                            <div style={{ "marginLeft": "17px" }}>
                                                <label className="">Allocated</label>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                        <div className="col-sm-1">
                                            <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                                                <option value={10}>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                        </div>
                                        <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                                        <div className="col-sm-6"></div>
                                        <div className="col-sm-1" style={{ "textAlign": "right" }}>Search</div>
                                        <div className="col-sm-2 d-flex justify-content-end">
                                            <input
                                                type="text"
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)} // Update searchQuery state
                                                className="form-control me-2" // Add margin to separate input and button

                                            />
                                            <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                                                <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row mb-3" style={{ maxHeight: "60vh", overflow: "auto", "marginLeft": "5px", "marginRight": "0px" }}>
                                        <table className="table m-0 table-hover table-bordered table-striped" style={{ "width": "100%" }}>
                                            <thead classname="table-light" style={{ position: "sticky", top: 0, zindex: 2 }}>
                                                <tr>
                                                    <th className="no-wrap">Serial No.</th>
                                                    <th className="no-wrap">Last Action</th>
                                                    <th className="no-wrap">Last Action Date</th>
                                                    <th className="no-wrap">Action By</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {stockSerialList.map((stock, index) => (
                                                    <tr key={stock.PK_StockSerial_ID} onClick={(event) => handleHistoryClick(event, stock.PK_StockSerial_ID)} style={{ cursor: 'pointer' }}>
                                                        <td style={{ "width": "20%" }}>

                                                            <span className="no-wrap">{stock.vc_Serial}</span>
                                                        </td>
                                                        <td className="no-wrap" dangerouslySetInnerHTML={{ __html: stock.vc_Reason }}></td>

                                                        <td className="no-wrap">{stock.dt_Added}</td>
                                                        <td className="no-wrap">{stock.DisplayName}</td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot style={{ position: "sticky", bottom: 0, zIndex: 2, backgroundColor: "white" }}>
                                                <tr>
                                                    <td colSpan={8}>
                                                        <div className="pagination-controls" style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                            Showing {1 + (currentPage * pageSize) - pageSize} to {currentPage * (Math.min(poCount, pageSize))} of {poCount} entries

                                                            {/* Last Page Button */}
                                                            <button
                                                                style={{ padding: '5px 8px', float: "right", marginLeft: "5px" }}
                                                                className='btn btn-info'
                                                                onClick={() => handlePageChange(totalPages)} // Navigate to last page
                                                                disabled={currentPage === totalPages}
                                                            >
                                                                Last
                                                            </button>

                                                            {/* Next Page Button */}
                                                            <button
                                                                style={{ padding: '5px 8px', float: "right", marginLeft: "5px" }}
                                                                className='btn btn-info'
                                                                onClick={() => handlePageChange(currentPage + 1)}
                                                                disabled={currentPage === totalPages}
                                                            >
                                                                Next
                                                            </button>

                                                            <span style={{ marginLeft: "10px", marginRight: "10px", float: "right" }}>
                                                                Page {currentPage} of {totalPages}
                                                            </span>

                                                            {/* Previous Page Button */}
                                                            <button
                                                                style={{ padding: '5px 8px', float: "right", marginRight: "5px", marginLeft: "5px" }}
                                                                className='btn btn-info'
                                                                onClick={() => handlePageChange(currentPage - 1)}
                                                                disabled={currentPage === 1}
                                                            >
                                                                Prev
                                                            </button>

                                                            {/* First Page Button */}
                                                            <button
                                                                style={{ padding: '5px 8px', float: "right" }}
                                                                className='btn btn-info'
                                                                onClick={() => handlePageChange(1)} // Navigate to first page
                                                                disabled={currentPage === 1}
                                                            >
                                                                First
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tfoot>


                                        </table>


                                    </div>

                                    <div className="modal-footer">
                                        <button type="button" onClick={onClose} className="btn btn-secondary">Close</button>
                                    </div>
                                </div>

                            )}
                        </div>

                    </Draggable>
                </div>
            </div>
            {isModalOpen && (
                <StockSerialHistoryModal StockSerialID={stockSerialID} onClose={handleCloseModal} />
            )}
        </div>
    );
}
export default PartFinancials;